import { render, staticRenderFns } from "./CourseEnrollment.vue?vue&type=template&id=ed5c9c1a&scoped=true&"
import script from "./CourseEnrollment.vue?vue&type=script&lang=js&"
export * from "./CourseEnrollment.vue?vue&type=script&lang=js&"
import style0 from "./CourseEnrollment.vue?vue&type=style&index=0&id=ed5c9c1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5c9c1a",
  null
  
)

export default component.exports